import { BffApiClient } from '@/common/services/api/bffClient';
import { absencesEndpoints } from '@/features/absences/endpoints/absencesEndpoints';
import { AbsenceModel } from '../types';

export class AbsencesService {
  private static api = BffApiClient.getInstance();

  /**
   * Get all absences for the current student
   */
  static async getAbsences(): Promise<AbsenceModel[]> {
    const response = await this.api.get(absencesEndpoints.getAbsences);
    return response.data as AbsenceModel[];
  }

  /**
   * Get absences for a specific year
   */
  // static async getAbsencesByYear(year: string): Promise<AbsenceModel[]> {
  //   const response = await this.api.get(
  //     absencesEndpoints.getAbsencesByYear(year)
  //   );
  //   return response.data as AbsenceModel[];
  // }

  /**
   * Justify an absence
   */
  // static async justifyAbsence(
  //   absenceId: number,
  //   justification: { reason: string; document?: File }
  // ): Promise<AbsenceModel> {
  //   const formData = new FormData();
  //   formData.append('reason', justification.reason);
  //   if (justification.document) {
  //     formData.append('document', justification.document);
  //   }

  //   const response = await this.api.post(
  //     absencesEndpoints.justifyAbsence(absenceId.toString()),
  //     formData
  //   );
  //   return response.data as AbsenceModel;
  // }

  /**
   * Declare a new absence
   */
  // static async declareAbsence(absence: {
  //   start: string;
  //   end: string;
  //   reason: string;
  //   courseId?: string;
  // }): Promise<AbsenceModel> {
  //   const response = await this.api.post(
  //     absencesEndpoints.declareAbsence,
  //     absence
  //   );
  //   return response.data as AbsenceModel;
  // }
}
